import { useEffect, useMemo, type ReactNode } from 'react';

import {
  createDefaultRpaRecorderLifecycleDeps,
  startRpaRecorderLifecycle,
  type RpaRecorderLifecycleDeps,
} from '@/app-shell/rpa/recorder/lifecycle/rpa-recorder-lifecycle-helpers';
import { useRecordings } from '@heidi/agents/data';

function useRpaRecorderLifecycle(deps?: RpaRecorderLifecycleDeps): void {
  const {
    addUploading,
    applyUploadState,
    applyUploadProgress,
    applyAnalysisStatus,
    mergePersisted,
  } = useRecordings();
  const resolvedDeps = useMemo(
    () => deps ?? createDefaultRpaRecorderLifecycleDeps(),
    [deps]
  );

  useEffect(() => {
    return startRpaRecorderLifecycle(resolvedDeps, {
      addUploading,
      applyUploadState,
      applyUploadProgress,
      applyAnalysisStatus,
      mergePersisted,
    });
  }, [
    addUploading,
    applyAnalysisStatus,
    applyUploadProgress,
    applyUploadState,
    mergePersisted,
    resolvedDeps,
  ]);
}

export function RpaRecorderLifecycleProvider({
  children,
  deps,
}: {
  readonly children: ReactNode;
  readonly deps?: RpaRecorderLifecycleDeps;
}): ReactNode {
  useRpaRecorderLifecycle(deps);
  return <>{children}</>;
}
